import {useState, useEffect, useContext} from 'react';
import {CookieConsentContext} from '../../utils/cookiesUtil';
import CookieConsentSettings from './components/CookieConsentSettings/CookieConsentSettings';
import CookieConsentModal from './components/CookieConsentModal/CookieConsentModal';
import useGoogleTag from './hooks/useGoogleTag/UseGoogleTag';
import useYandexMetrika from './hooks/useYandexMetrika/UseYandexMetrika';

const CookieConsentManager = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSettingsVisible, setIsSettingsVisible] = useState(false);
  const {cookieConsent, setCookieConsent} = useContext(CookieConsentContext);

  useEffect(() => {
    if (!cookieConsent) {
      setIsModalVisible(true);
    }
  }, []);

  useGoogleTag();
  useYandexMetrika();

  if (!isModalVisible) {
    if (isSettingsVisible) {
      return <CookieConsentSettings setIsModalVisible={setIsModalVisible} />;
    }
    return <></>;
  }

  return <CookieConsentModal setIsModalVisible={setIsModalVisible} setIsSettingsVisible={setIsSettingsVisible} />;
};

export default CookieConsentManager;
